import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { CycleRecommendationApiClient } from '../../api-clients';
const {
  Provider,
  ...client
} = CycleRecommendationApiClient;
export const CycleRecommendationExtension = createModuleExtension({
  extensionName: 'cycleRecommendationExtension',
  Provider,
  SDK: {
    cycleRecommendationApiClient: client
  }
});
//# sourceMappingURL=cycle-recommendation.extension.js.map